var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cell__wrapper" }, [
    _c("div", { staticClass: "cell", on: { click: _vm.expandHandler } }, [
      _vm.cellData.extandable && _vm.showExpandIcon
        ? _c("div", { staticClass: "cell__expand-icon-wrapper" }, [
            _c("div", {
              staticClass: "cell__expand-icon",
              domProps: { innerHTML: _vm._s(_vm.expandIcon) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteColumn
        ? _c("div", { staticClass: "cell__delete-wrapper" }, [
            _c("div", {
              staticClass: "cell__delete-icon",
              domProps: { innerHTML: _vm._s(_vm.deleteIcon) },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.$emit("delete")
                }
              }
            })
          ])
        : _vm.cellData.type === "button"
        ? _c(
            "div",
            [
              _c("q-btn", {
                attrs: { label: _vm.cellData.value },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.$emit("btn-click")
                  }
                }
              })
            ],
            1
          )
        : _vm.cellData.format
        ? _c("div", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.cellData.format(_vm.cellData.value)) +
                "\n    "
            )
          ])
        : _vm.cellData.type === "boolean"
        ? _c("div", [
            _vm._v(
              "\n      " + _vm._s(_vm.cellData.value.toString()) + "\n    "
            )
          ])
        : _c(
            "div",
            {
              class: [
                "cell__value",
                { extandable: _vm.cellData.extandable && _vm.showExpandIcon }
              ]
            },
            [_vm._v("\n      " + _vm._s(_vm.cellData.value) + "\n    ")]
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }